import axios from "axios";

export const getOraVersionsAPI = async params => {
  let response = await axios({
    url: `/api/v2/statistic/ora-versions`,
    method: "GET",
    params
  });
  const deviceOSType = response.data.ora_versions;
  return deviceOSType;
};
